class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    // Get the details element
    var details = document.querySelector(
      ".mobile-facets__disclosure.disclosure-has-popup"
    );

    // Listen for the 'toggle' event
    details.addEventListener("toggle", function () {
      if (this.open) {
        // The details element is open, disable scrolling
        document.body.style.overflow = "hidden";
      } else {
        // The details element is closed, enable scrolling
        document.body.style.overflow = "auto";
      }
    });

    this.xButton = document.querySelector(".mobile-facets__close");

    this.scrollContainer = this.querySelector(".mobile-facets__inner");

    this.onScrollHandler = this.onScroll.bind(this);

    this.scrollContainer.addEventListener("scroll", this.onScrollHandler);

    // Remove the event listener for the "input" event
    // const facetForm = this.querySelector("form");
    // facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    // Add a click event listener to the "Apply" button
    const applyButton = this.querySelector("#applyButton");
    applyButton.addEventListener("click", this.onApplyButtonClick.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScroll() {
    if (this.scrollContainer.scrollTop > 0) {
      this.xButton.classList.add("mobile-facets__close--shadow");
    } else {
      this.xButton.classList.remove("mobile-facets__close--shadow");
    }
  }

  onApplyButtonClick(event) {
    event.preventDefault();
    const facetForm = this.querySelector("form");
    const searchParams = this.createSearchParams(facetForm);
    this.onSubmitForm(searchParams, event);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateUrlWithPathname = window.location.pathname) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${updateUrlWithPathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateUrlWithPathname) FacetFiltersForm.updateURLHash(searchParams, updateUrlWithPathname);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        const saleFiltersScrollLeft = document.querySelector(".sale-filters").scrollLeft;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        if (saleFiltersScrollLeft) {
          document.querySelector(".sale-filters").scrollLeft = saleFiltersScrollLeft;
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    const saleFiltersScrollLeft = document.querySelector(".sale-filters").scrollLeft;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    if (saleFiltersScrollLeft) {
      document.querySelector(".sale-filters").scrollLeft = saleFiltersScrollLeft;
    }
  }

  static renderProductGridContainer(html) {
    if (!html) return;

    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams, pathname = window.location.pathname) {
    history.pushState(
      { searchParams },
      "",
      `${pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    const sizeFilters = formData.getAll("filter.v.m.custom.size");

    const finalFilters = [];

    ["In Stock", "Pre-Order"].forEach((blanketFilter) => {
      const availabilityFilters = formData.getAll(
        "filter.v.m.custom.availability"
      );

      if (availabilityFilters.includes(blanketFilter)) {
        finalFilters.push(blanketFilter);

        let setFilters = FacetFiltersForm.setFilters.filter((filter) =>
          filter.startsWith(`_${blanketFilter} `)
        );

        if (sizeFilters[0]) {
          setFilters = setFilters.filter((filter) =>
            sizeFilters.includes(filter.replace(`_${blanketFilter} `, ""))
          );
        }

        setFilters.forEach((filter) => {
          finalFilters.push(filter);
        });
      }
    });

    formData.delete("filter.v.m.custom.availability");

    finalFilters.forEach((filter) => {
      formData.append("filter.v.m.custom.availability", filter);
    });

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    const isButton = event.target.tagName === "BUTTON";
    const isSVG = event.target.tagName === "svg";

    if (isSVG) {
      const allRadios = document.querySelectorAll(".sort-select");
      allRadios.forEach((radio, index) => {
        if (index === 0) {
          // Assuming the first option should be checked
          radio.checked = true;
        } else {
          radio.checked = false;
        }
      });
    } else if (isButton) {
      // store the sort value to be used later when 'apply' is clicked
      this.selectedSortValue = event.target.dataset.value;
      // add a selected class to visually show which button is selected
      document.querySelectorAll(".sort-button").forEach((button) => {
        button.classList.remove("selected");
      });
      event.target.classList.add("selected");
    } else if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const searchParams =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    const pathname = event.currentTarget.href.split("?")[0];
    FacetFiltersForm.renderPage(searchParams, undefined, pathname);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.setFilters = [
  "_In Stock XS",
  "_In Stock S",
  "_In Stock M",
  "_In Stock L",
  "_In Stock XL",
  "_In Stock 1X",
  "_In Stock 2X",
  "_In Stock 3X",
  "_Pre-Order XS",
  "_Pre-Order S",
  "_Pre-Order M",
  "_Pre-Order L",
  "_Pre-Order XL",
  "_Pre-Order 1X",
  "_Pre-Order 2X",
  "_Pre-Order 3X",
];

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    this.facetLink = facetLink;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    this.facetLink.classList.add('facet-link--loading');
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener("DOMContentLoaded", function() {

  const clearFiltersLink = document.getElementById("clear-all-filters");

  clearFiltersLink.addEventListener("click", function(event) {
    event.preventDefault();

    document.querySelectorAll('.mobile-facets__checkbox').forEach(function(checkbox) {
      checkbox.checked = false;
    });

    const priceRangeInputs = document.querySelectorAll('.field__input');
    priceRangeInputs.forEach(function(input) {
      input.value = '';
    });

  });
});

let prevOption;

document.querySelectorAll('input[name="sort_by"]').forEach((option) => {
  option.addEventListener('click', function(event) {
    if (this === prevOption) {
      this.checked = false;
      document.getElementById('sort_manual').checked = true;
      prevOption = null;
    } else {
      prevOption = this;
    }
  });
});

class ClearAllFilters extends HTMLElement {
  constructor() {
    super();
    this.clearFiltersLink = document.getElementById("clear-all-filters");
  }

  connectedCallback() {
    this.clearFiltersLink.addEventListener("click", function (event) {
      event.preventDefault();

      document.body.style.overflow = "auto";
    });
  }
}

customElements.define('clear-all-filters', ClearAllFilters);
